import React from 'react';
import { useRouteError } from 'react-router-dom';

import CriticalError from './examples/CriticalError';
import NotFoundError from './examples/NotFoundError';

const ErrorProvider = () => {
  const error = useRouteError() as Error;
  const componentSwitch = () => {
    switch (error.name) {
      case 'TypeError':
      case 'ReferenceError': {
        return <CriticalError />;
      }
      default: {
        return <NotFoundError />;
      }
    }
  };
  return componentSwitch();
};

export default ErrorProvider;
